/**
 * Recursively replaces all values in an object that match `currentValue` with `replaceValue`.
 * @param obj The object to process.
 * @param currentValue The value to search for (e.g., "").
 * @param replaceValue The value to replace with (e.g., null).
 * @returns A new object with replacements applied.
 */
export const replaceObjectValues = <T, U, V>(
  obj: T,
  currentValue: U,
  replaceValue: V
): any =>
  Array.isArray(obj)
    ? obj.map((item) => replaceObjectValues(item, currentValue, replaceValue))
    : obj !== null && typeof obj === "object"
    ? Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [
          key,
          value === currentValue
            ? replaceValue
            : replaceObjectValues(value, currentValue, replaceValue),
        ])
      )
    : obj;
